import React, { useState } from "react";
import Logo from "../../Logo";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export default function AdminNavbar() {
    const [isActive, setisActive] = useState(false);

    const navigate = useNavigate();

    const handleMenuToggle = () => {
        setisActive(!isActive);
    };

    const handleLogout = () => {
        localStorage.removeItem("token");
        navigate("/login");
    };

    return (
        <div className="">
            <nav
                className="navbar"
                role="navigation"
                aria-label="main navigation"
            >
                <div className="navbar-brand">
                    <Link className="" to="/admin">
                        <Logo />
                    </Link>
                    <Link className="" to="/admin">
                        <h1 className="is-size-3 m-4 p-3 title">CSEA</h1>
                    </Link>

                    <button
                        onClick={handleMenuToggle}
                        style={{ marginTop: "19px", marginRight: "19px" }}
                        className={`navbar-burger ${
                            isActive ? "is-active" : ""
                        }`}
                        aria-label="menu"
                        aria-expanded="false"
                        data-target="navbarBasicExample"
                    >
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                    </button>
                </div>

                <div
                    id="navbarBasicExample"
                    className={`navbar-menu ${isActive ? "is-active" : ""}`}
                >
                    <div className="navbar-start"></div>

                    <div className="navbar-end">
                        <Link className="navbar-item is-tab" to="/admin">
                            Admin Home
                        </Link>
                        <Link className="navbar-item is-tab" to="/">
                            CSEA Home
                        </Link>
                        <div className="navbar-item">
                            <div className="buttons">
                                <button
                                    onClick={handleLogout}
                                    className="button is-outlined is-danger"
                                >
                                    Log Out
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    );
}
